import React from 'react';
import classNames from 'classnames';

import styles from './style.scss';


const BooksetHorizontalCardEmpty = ({ extraClassName }) => {
  return (
    <div className={classNames(styles.item, extraClassName)}>
      <div className={styles.image} />
      <div className={styles.content}>
        <div className={styles.amount}>
          <div className={styles.amountPicture} />
          <span className={styles.amountBook} />
        </div>
        <div className={styles.title} />
      </div>
    </div>
  );
};

export default BooksetHorizontalCardEmpty;
